import React
	from 'react';
import ReactDOM
	from 'react-dom';
import $
	from 'jquery';
import './index.css';
import App
	from './App';
// import registerServiceWorker from './registerServiceWorker';
import { CookiesProvider } from 'react-cookie';

if ( process.env.NODE_ENV === 'development' ) {

	const a11y = require( 'react-a11y' ).default;

	a11y( React, ReactDOM, {
		rules : {
			'img-uses-alt'      : 'warn',
			'img-redundant-alt' : [ 'warn', [ 'image', 'photo', 'foto', 'bild' ] ],
		},
		// plugins: [
		//     "react-a11y-plugin-aria-wai"
		// ]
	} );

}

document.addEventListener( "DOMContentLoaded", function () {

	let $pauMainAcces      = $( '#pauMainAcces' ),
		siteurl            = $pauMainAcces.attr( 'data-siteurl' ),
		urlBase            = `${siteurl}/wp-json/pau/v1/`,
		urlPauActivate     = `${urlBase}pau_activate`,
		pauActivate        = false,
		promisePauActivate = fetch( urlPauActivate )
			.then( res => {
				return res.json();
			} )
			.then( data => {

				pauActivate = data.pau_activate;

			} )
			.catch( error => console.log( error ) );

	promisePauActivate.then( _ => {

		if ( pauActivate ) {

			ReactDOM.render(
				<CookiesProvider>
					<App/>
				</CookiesProvider>,
				document.getElementById( 'pauMainAcces' ) );

			// $("#pauMainAcces")
			//     .before( "<div id=\"pauBackMain\"></div>" )
			//     .after( "<div id=\"pauContMain\" data-value=\"1\"></div><div id=\"pauContPanel\" data-value=\"1\"></div>" );

			// setTimeout( function() {
			//     console.log( "\n".repeat( 20 ) );
			// }, 2000);

			// registerServiceWorker();


		}

	} );

} );



// WEBPACK FOOTER //
// ./src/index.js